// extracted by mini-css-extract-plugin
export var activeFilterButton = "_o3-c";
export var backButton = "_o3-4";
export var backIcon = "_o3-5";
export var chevronShortcut = "_o3-6";
export var container = "_o3-1";
export var editor = "_o3-8";
export var editorWrapper = "_o3-7";
export var prefix = "_o3-2";
export var searchIcon = "_o3-3";
export var suffix = "_o3-9";
export var suffixContent = "_o3-a";
export var suffixText = "_o3-b";
export var wrapper = "_o3-0";